import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon, USER_INTERFACE_TICK_DONE } from '@bwoty-web/styleguide';
import { destinationTraits } from '../../appSettings';
import './preferenceOption.scss';

const PreferenceOption = ({
  selected,
  onSelect,
  displayName,
  iconPath,
  id,
}) => {
  const buttonClasses = classnames({
    'vf-preference-picker-option__button': true,
    'vf-preference-picker-option__button--location':
      id === destinationTraits.LOCATION,
    'vf-preference-picker-option__button--temperature':
      id === destinationTraits.TEMPERATURE,
    'vf-preference-picker-option__button--flight-time':
      id === destinationTraits.FLIGHT_TIME,
    'vf-preference-picker-option__button--surprise':
      id === destinationTraits.SURPRISE,
  });
  return (
    <div
      tabIndex="0"
      role="button"
      onClick={() => {
        onSelect(id);
      }}
      onKeyDown={(e) => {
        if (e.keycode === 13) {
          onSelect(id);
        }
      }}
      className="vf-preference-picker__option"
    >
      <div className="vf-preference-picker-option__inner-wrapper">
        <button
          type="button"
          className={buttonClasses}
          data-test={`${id.toLowerCase()}-button${selected ? '-selected' : ''}`}
        >
          {selected && (
            <div className="vf-preference-picker-option__button--selected">
              <Icon fill="#fff" path={USER_INTERFACE_TICK_DONE} size="xs" />
            </div>
          )}
          <Icon
            className="vf-preference-picker-option__icon"
            path={iconPath}
            size="large"
          />
          <p>{displayName}</p>
        </button>
      </div>
    </div>
  );
};

PreferenceOption.propTypes = {
  id: PropTypes.string.isRequired,
  iconPath: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  displayName: PropTypes.string.isRequired,
};

export default PreferenceOption;
